import Vue from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'
import Antd from 'ant-design-vue';
import VueAxios from 'vue-axios'
import Axios from '@/utils/ajax'
import * as echarts from 'echarts'

import { isAuth, moment, encrypt } from './utils'
import { Button, Select, Tabs, Option, Row, Radio, InputNumber, TabPane} from 'element-ui';
// import ElementUI from 'element-ui';
import VueCookies from 'vue-cookies'                                  //cookie协助登录
import qs from 'qs'                                                   //querystring转换库
import lodash from 'lodash'                                           //loadash工具库
import VueCron from 'vue-cron'                                        // 引入cron表达式控件
import VueAnimateNumber from 'vue-animate-number'                    // 引入数字滚动插件
import VueKinesis from 'vue-kinesis'
// import Video from 'video.js'
// import 'video.js/dist/video-js.css'


// 引入样式文件
import 'ant-design-vue/dist/antd.css';
import './assets/css/global.scss'
import 'element-ui/lib/theme-chalk/index.css';

// 挂载全局
Vue.config.productionTip = false
Vue.use(VueAxios, Axios)
Vue.prototype.$moment = moment
Vue.prototype.$IA = isAuth
Vue.prototype.$echarts = echarts
Vue.use(Antd);
// Vue.use(ElementUI);
Vue.use(Button);
Vue.use(Select);
Vue.use(Row);
Vue.use(Option);
Vue.use(Tabs);
Vue.use(Radio);
Vue.use(InputNumber);
Vue.use(TabPane);
Vue.use(VueAnimateNumber)
Vue.use(VueKinesis);
// Vue.prototype.$http = httpRequest // axios请求方法
// Vue.prototype.isAuth = isAuth     // 权限方法
Vue.use(VueCookies) //缓存
Vue.prototype.$qs = qs
Vue.prototype.$lodash = lodash
Vue.prototype.$encrypt = encrypt
Vue.prototype.IMAGE_URL = process.env.NODE_ENV === 'production' ? window.env.IMAGE_BASE_URL : process.env.VUE_APP_IMAGE_URL                  // 图片回显接口配置
Vue.use(VueCron)
// Vue.prototype.$video = Video
// Vue.use(Calendar);

new Vue({
  store,
  router,
  render: h => h(App)
}).$mount('#app')
